export enum NotificationSeverityEnum {
  INFO,
  SUCCESS,
  WARN,
  ERROR
}
